module.exports = __webpack_public_path__ + "static/img/dukewenhua.6b2cf59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/dukewenhua.jpg
// module id = HaTD
// module chunks = 36